import { Vec3 } from 'cc';
import { PathSegmentDataConfigType } from './PathDataType';

export default class ControlPointPair {
    public readonly config: PathSegmentDataConfigType;
    private _mainControlPoint: Vec3;
    private _secondaryControlPoint1: Vec3;
    private _secondaryControlPoint2: Vec3;

    constructor(p1: Vec3, p2: Vec3 = p1, p3: Vec3 = p1, config: PathSegmentDataConfigType = null) {
        this._mainControlPoint = p1;
        this._secondaryControlPoint1 = p2;
        this._secondaryControlPoint2 = p3;
        this.config = config;
    }

    public get points(): Vec3[] {
        return [this._secondaryControlPoint1, this._mainControlPoint, this._secondaryControlPoint2];
    }
}
